var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFF1D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFBEF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 33V31H29.5V25H30.5V23H26.5V25H27.5V31H26.5V33H30.5ZM28.5 18C29.8132 18 31.1136 18.2587 32.3268 18.7612C33.5401 19.2638 34.6425 20.0003 35.5711 20.9289C36.4997 21.8575 37.2362 22.9599 37.7388 24.1732C38.2413 25.3864 38.5 26.6868 38.5 28C38.5 30.6522 37.4464 33.1957 35.5711 35.0711C33.6957 36.9464 31.1522 38 28.5 38C27.1868 38 25.8864 37.7413 24.6732 37.2388C23.4599 36.7362 22.3575 35.9997 21.4289 35.0711C19.5536 33.1957 18.5 30.6522 18.5 28C18.5 25.3478 19.5536 22.8043 21.4289 20.9289C23.3043 19.0536 25.8478 18 28.5 18ZM28.5 20C26.3783 20 24.3434 20.8429 22.8431 22.3431C21.3429 23.8434 20.5 25.8783 20.5 28C20.5 30.1217 21.3429 32.1566 22.8431 33.6569C24.3434 35.1571 26.3783 36 28.5 36C30.6217 36 32.6566 35.1571 34.1569 33.6569C35.6571 32.1566 36.5 30.1217 36.5 28C36.5 25.8783 35.6571 23.8434 34.1569 22.3431C32.6566 20.8429 30.6217 20 28.5 20Z",
    fill: "#B1A279"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmInfo);
export default __webpack_public_path__ + "static/media/confirm-info.7c54887c979096777e99a801b29954b7.svg";
export { ForwardRef as ReactComponent };